export const SHARED_EMAILS: { navn: string; email: string }[] = [
  {
    navn: "Advokatuddannelsen",
    email: "uddannelse@advokatsamfundet.dk",
  },
  {
    navn: "Advokatuddannelsen",
    email: "retssagsprove@advokatsamfundet.dk",
  },
  {
    navn: "Efteruddannelse",
    email: "efteruddannelse@advokatsamfundet.dk",
  },
  {
    navn: "Advokatsamfundet",
    email: "postkasse@advokatsamfundet.dk",
  },
  {
    navn: "Tilsynsafdelingerne",
    email: "tilsyn@advokatsamfundet.dk",
  },
  {
    navn: "Advokatsamfundets sekretariat",
    email: "AdvokatsamfundetsSekretariat@advokatsamfundet.dk",
  },
];
export const FMUKURSUS_KATEGORIER: { navn: string; nr: number }[] = [
  { navn: "TEMA", nr: 1 },
  //{ navn: "AU", nr: 2 },
  {
    navn: "FMU",
    nr: 3,
  },
  //{navn: "Fuldmægtig",nr: 4,},
  { navn: "FMU Prøve", nr: 5 },
];
